export default class AdminEditButton {
  constructor(button) {
    this.button = button;
    this.section = button.parentElement;
    this.content = this.section.querySelector(
      '.admin-edit-info__content-container'
    );
    this.closeButton = this.section.querySelector(
      '.admin-edit-info__close-button'
    );

    if (this.content && this.closeButton) {
      this.events();
    }
  }

  events() {
    this.button.addEventListener('click', () =>
      this.toggleContent(this.content)
    );
    this.closeButton.addEventListener('click', () =>
      this.hideContent(this.content)
    );
  }

  toggleContent(content) {
    if (content.classList.contains('show-admin-content')) {
      content.classList.remove('show-admin-content');
    } else {
      content.classList.add('show-admin-content');
    }
  }

  hideContent(content) {
    content.classList.remove('show-admin-content');
  }
}
